import React from "react";
export default ({ currentPage, onClick, lastPage }) => (
  <a
    {...{
      className: "pagination-next",
      disabled: currentPage >= lastPage,
      onClick: currentPage >= lastPage ? undefined : onClick(++currentPage)
    }}
  >
    Next page
  </a>
);



// WEBPACK FOOTER //
// ./src/components/Pagination/NextPage.js